import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "d-flex align-center",
  style: {"width":"100%"}
}
const _hoisted_2 = { class: "d-flex align-center" }
const _hoisted_3 = { class: "pl-2 date-button" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_date_picker = _resolveComponent("v-date-picker")!
  const _component_v_locale_provider = _resolveComponent("v-locale-provider")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_menu = _resolveComponent("v-menu")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_menu, {
      ref: "menu",
      modelValue: _ctx.open,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.open) = $event)),
      "close-on-content-click": false,
      transition: "scale-transition",
      "offset-y": "",
      "min-width": "auto"
    }, {
      activator: _withCtx(({ props }) => [
        _createVNode(_component_v_btn, _mergeProps({
          variant: "text",
          color: "primary"
        }, props, { large: "" }), {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_v_icon, {
                start: "",
                size: "x-large",
                color: "primary"
              }, {
                default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                  _createTextVNode("mdi-calendar", -1)
                ]))]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.formattedDate), 1)
            ])
          ]),
          _: 1
        }, 16)
      ]),
      default: _withCtx(() => [
        _createVNode(_component_v_card, {
          variant: "flat",
          elevation: "4",
          class: "bg-white"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_locale_provider, { locale: "en" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_date_picker, {
                  "model-value": _ctx.modelValue,
                  "onUpdate:modelValue": _ctx.updateValue,
                  color: "primary",
                  variant: "flat",
                  "hide-details": ""
                }, null, 8, ["model-value", "onUpdate:modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createElementVNode("div", null, [
      _createVNode(_component_v_btn, {
        onClick: _ctx.subtract,
        variant: "text",
        color: "primary"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_icon, { start: "" }, {
            default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
              _createTextVNode("mdi-chevron-left", -1)
            ]))]),
            _: 1
          }),
          _createTextVNode(" " + _toDisplayString(_ctx.$t('common.previousDay')), 1)
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    _createElementVNode("div", null, [
      _createVNode(_component_v_btn, {
        onClick: _ctx.add,
        variant: "text",
        color: "primary"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('common.nextDay')) + " ", 1),
          _createVNode(_component_v_icon, { end: "" }, {
            default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
              _createTextVNode("mdi-chevron-right", -1)
            ]))]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["onClick"])
    ])
  ]))
}